import { createContext } from "react";
import { AriaTelemetryClient } from "@mwt/web-js-telemetry";

export const TelemetryContext = createContext<
  AriaTelemetryClient | undefined
>(undefined);
